import React from 'react';
import { useAppFilters } from './useAppFilters';
import { ASSET_STUDIO, ASSETS_PREVIEW, ASSETS_TYPE } from '@/types/shared/navigation-tabs.enums';

export function useActiveTab() {
  const { assetStudio, assetsPreview, assetsType } = useAppFilters();
  const isVisualAI = assetStudio === ASSET_STUDIO.VISUAL_AI;
  const isMaintenance =
    assetStudio === ASSET_STUDIO.MAINTENANCE_DATA || assetsPreview === ASSETS_PREVIEW.MAINTENANCE_DATA;
  const isDiagnostics = assetStudio === ASSET_STUDIO.DIAGNOSTICS;
  const isSensorData = assetStudio === ASSET_STUDIO.SENSOR_DATA;
  const isAlarms = assetStudio === ASSET_STUDIO.ALARMS;
  return { isVisualAI, isMaintenance, isDiagnostics, isSensorData, isAlarms };
}
